import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import useCheckPermission from '../../hooks/useCheckPermission';
import tenantService from './tenantService';
import TenantForm, { TenantTypes } from './TenantForm';

const TenantCreate = (props: any) => {
  const { onSave = null, navigateBack = true, handleCancel = null } = props;
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [errors, setErrors] = useState<string[]>([]);
  const [createdApiKey, setCreatedApiKey] = useState<string | null>(null);
  const { canPlatform } = useCheckPermission();

  const onSubmit = (entity: any, setSubmitting: any) => {
    dispatch({ type: 'SHOW_SAVE' });
    tenantService
      .create(entity)
      .then((response) => {
        if (response.hasError) {
          setErrors(response.errorMessages ?? []);
          enqueueSnackbar((response.errorMessages ?? []).join(','), {
            variant: 'error',
          });
        } else {
          const apiKey = response.result?.apiKey ?? response.result?.ApiKey;
          if (apiKey) {
            setCreatedApiKey(apiKey);
            enqueueSnackbar('Bérlő létrehozva. Másold le most az API kulcsot.', {
              variant: 'warning',
              persist: true,
            });
          } else {
            enqueueSnackbar('Success!', { variant: 'success' });
          }
          if (onSave) onSave(response.result);
          if (navigateBack && !apiKey) navigate(-1);
          if (apiKey && response.result?.id) {
            navigate(`/tenants/${response.result.id}/admin`, {
              state: { apiKey },
            });
          }
        }
      })
      .finally(() => {
        dispatch({ type: 'HIDE' });
        if (setSubmitting) setSubmitting(false);
      });
  };

  return (
    <TenantForm
      entity={{
        id: '',
        name: '',
        slug: '',
        type: TenantTypes.Organization,
        contactName: '',
        contactEmail: '',
        region: '',
        defaultLanguage: 'hu',
        timeZone: 'Europe/Budapest',
        tenantGroupId: null,
        groupDisplayName: '',
        deepLinkSlug: '',
      }}
      readonly={!canPlatform(['ManageTenants'])}
      onSubmit={onSubmit}
      errors={errors}
      createdApiKey={createdApiKey}
      handleCancel={() =>
        handleCancel != null ? handleCancel() : navigate(-1)
      }
    />
  );
};

export default TenantCreate;
